import React, { FunctionComponent } from "react";
import clsx from "clsx";
import {
  useTheme,
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Menu,
} from "@material-ui/core";
import {
  AccountCircle,
  ChevronLeft,
  ChevronRight,
  Inbox,
  Menu as MenuIcon,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { onLogoutRequest } from "redux/actions/user.actions";
import { useStyles } from "./styles";
import { IProps } from "./types";

const DashboardLayout: FunctionComponent<IProps> = (props: IProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openOptions = Boolean(anchorEl);
  const dispatch = useDispatch();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const onLogout = () => {
    handleClose();
    dispatch(onLogoutRequest());
  };

  return (
    <div className={classes.root} data-testid="dashboardLayout">
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            data-testid="iconButton"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.textSpacing}>
            BMS B2B Dashboard
          </Typography>
          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={openOptions}
              onClose={handleClose}
            >
              <MenuItem onClick={onLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        </div>
        <Divider />
        <List>
          <Link to="/dashboard/clients" className={classes.noUnderline}>
            <ListItem button key="Clients">
              <ListItemIcon>
                <Inbox />
              </ListItemIcon>
              <ListItemText primary="Clients" />
            </ListItem>
          </Link>
          <Link to="/dashboard/campaigns" className={classes.noUnderline}>
            <ListItem button key="Campaigns">
              <ListItemIcon>
                <Inbox />
              </ListItemIcon>
              <ListItemText primary="Campaigns" />
            </ListItem>
          </Link>
          <Link to="/dashboard/templates" className={classes.noUnderline}>
            <ListItem button key="Templates">
              <ListItemIcon>
                <Inbox />
              </ListItemIcon>
              <ListItemText primary="Templates" />
            </ListItem>
          </Link>
          <Link to="/dashboard/users" className={classes.noUnderline}>
            <ListItem button key="users">
              <ListItemIcon>
                <Inbox />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItem>
          </Link>
          <Link to="/dashboard/assets" className={classes.noUnderline}>
            <ListItem button key="assets">
              <ListItemIcon>
                <Inbox />
              </ListItemIcon>
              <ListItemText primary="Assets" />
            </ListItem>
          </Link>
          <Link to="/dashboard/text-variables" className={classes.noUnderline}>
            <ListItem button key="Text variables">
              <ListItemIcon>
                <Inbox />
              </ListItemIcon>
              <ListItemText primary="Text variables" />
            </ListItem>
          </Link>
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
};

export default DashboardLayout;
